import {Link} from "react-router-dom";
import Icon from "../../assets/images/analyse.svg";
import {ExportButton} from "../ExportButton/ExportButton";

export const columnAnalysisDef = (
    isAdmin,
    isBusiness,
    mode,
    isRecipientSelected,
    onToggleRecipient,
    areAllPagesSelected,
    onToggleAllPages,
    areCurrentPageRecipientsSelected,
    onToggleCurrentPageRecipients
) => {
    let analysisItems = [];
    const prefix = isBusiness?"business":"admin";
    const isEmail = mode && mode === 'Email';

    if (isEmail) {
        analysisItems.push({
            id: "emailSelection",
            header: () => (
                <div className="analysis-email-selection-options">
                    <label className="analysis-email-checkbox">
                        <input
                            className="analysis-email-native-checkbox"
                            type="checkbox"
                            checked={areAllPagesSelected}
                            onChange={(event) => onToggleAllPages(event.target.checked)}
                        />
                        <span className="analysis-email-checkmark" aria-hidden="true" />
                        <span className="analysis-email-checkbox-label">All</span>
                    </label>
                    <label className="analysis-email-checkbox">
                        <input
                            className="analysis-email-native-checkbox"
                            type="checkbox"
                            checked={areAllPagesSelected || areCurrentPageRecipientsSelected}
                            onChange={(event) => onToggleCurrentPageRecipients(event.target.checked)}
                        />
                        <span className="analysis-email-checkmark" aria-hidden="true" />
                        <span className="analysis-email-checkbox-label">Page</span>
                    </label>
                </div>
            ),
            cell: ({row}) => {
                const canSelect = Boolean(row.original.examEmail || row.original.email);
                return (
                    <label
                        className="analysis-email-checkbox"
                        onClick={(event) => event.stopPropagation()}
                    >
                        <input
                            className="analysis-email-native-checkbox"
                            type="checkbox"
                            checked={canSelect && (areAllPagesSelected || isRecipientSelected(row.original))}
                            disabled={!canSelect}
                            onChange={() => onToggleRecipient(row.original)}
                            aria-label={`Select ${row.original.examFullName || row.original.examEmail || "recipient"}`}
                        />
                        <span className="analysis-email-checkmark" aria-hidden="true" />
                    </label>
                );
            },
        });
    }

    if (!isEmail) {
        analysisItems.push({
            accessorKey: "sn",
            header: "#",
            cell: ({getValue}) => (
                <div style={{padding: "0px 15px"}}>{getValue()}</div>
            ),
        });
    }

    analysisItems.push({
            accessorKey: "examLogo",
            header: "",
            cell: ({getValue}) => {
                const imageitem = getValue();
                return (<div className="row4">
                        <img src={imageitem} alt="logo" width="50px" height="50px" className="examlogo"/>
                    </div>
                )
            },
        });

    if(isAdmin){
        analysisItems.push(
            {
                accessorKey: "examFullName",
                header: "Full Name",
                cell: ({getValue}) => {
                    return (
                        <div className="row1">
                            <small>{getValue()}</small>
                        </div>
                    )
                },
            });
        if (isEmail) {
            analysisItems.push({
                accessorKey: "examEmail",
                header: "Email",
                cell: ({getValue}) => (
                    <div className="row1">
                        <small>{getValue()}</small>
                    </div>
                ),
            });
        }
    }
    analysisItems.push(
        {
            accessorKey: "session",
            header: "Name",
            cell: ({getValue}) => {
                const subjectitem = getValue();
                return (
                    <div className="row1">
                        <small>{subjectitem}</small>
                    </div>
                );
            },
        },
        {
            accessorKey: "subject",
            header: "Subjects",
            cell: ({getValue}) => {
                const subject = getValue();
                return (
                    <>
                        <div className="row4">
                            <small>{subject}</small>
                        </div>
                    </>
                );
            },
        },
        {
            accessorKey: "attemptDate",
            header: "Date Attempted",
            cell: ({getValue}) => {
                const date = getValue();
                return (
                    <div className="row3">
                        <small>{date?.date}</small>
                        <br/>
                        <small>{date?.time}</small>
                    </div>
                )
            },
        },
        {
            accessorKey: "endDate",
            header: "End Date",
            cell: ({getValue}) => {
                const date = getValue();
                return (
                    <div className="row3">
                        <small>{date?.date}</small>
                        <br/>
                        <small>{date?.time}</small>
                    </div>
                )
            },
        },
        {
            accessorKey: "score",
            header: "Total Score",
            cell: ({getValue}) => {
                return (
                    <div className="row3">
                        <small>{getValue()}</small>
                    </div>
                )
            },
        },
        {
            accessorKey: "duration",
            header: "Time Used",
            cell: ({getValue}) => {
                return (
                    <div className="row4">
                        <small>{getValue()}</small>
                    </div>
                )
            },
        }
    );

    if (!isEmail) {
        analysisItems.push({
            accessorKey: "action",
            header: "Action",
            cell: ({getValue}) => {
                const id = getValue();
                return (
                    <div className="row3 analy-btn" style={{paddingRight: "10px"}}>
                        <Link to={isAdmin ? `/${prefix}/analysis-dashboard/${id}` : `/analysis-dashboard/${id}`}>
                            <button className="no-mag">
                                <img src={Icon} alt="icon"/>
                                Details
                            </button>
                        </Link>
                        <ExportButton className="exp-btn no-mag" id={id}/>
                    </div>
                );
            },
        });
    }
    return analysisItems;
}
